var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearAni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes Brush_t { 0% { transform: translate(12.141791px,3.457324px) rotate(0deg) translate(-12.141791px,-3.457324px); animation-timing-function: cubic-bezier(0,0,0.58,1); } 12.5% { transform: translate(12.141791px,3.457324px) rotate(14deg) translate(-12.141791px,-3.457324px); animation-timing-function: cubic-bezier(0.42,0,1,1); } 25% { transform: translate(12.141791px,3.457324px) rotate(0deg) translate(-12.141791px,-3.457324px); animation-timing-function: cubic-bezier(0,0,0.58,1); } 37.5% { transform: translate(12.141791px,3.457324px) rotate(-14deg) translate(-12.141791px,-3.457324px); } 50% { transform: translate(12.141791px,3.457324px) rotate(0deg) translate(-12.141791px,-3.457324px); animation-timing-function: cubic-bezier(0,0,0.58,1); } 62.5% { transform: translate(12.141791px,3.457324px) rotate(14deg) translate(-12.141791px,-3.457324px); animation-timing-function: cubic-bezier(0.42,0,1,1); } 75% { transform: translate(12.141791px,3.457324px) rotate(0deg) translate(-12.141791px,-3.457324px); animation-timing-function: cubic-bezier(0,0,0.58,1); } 87.5% { transform: translate(12.141791px,3.457324px) rotate(-14deg) translate(-12.141791px,-3.457324px); animation-timing-function: cubic-bezier(0.42,0,1,1); } 100% { transform: translate(12.141791px,3.457324px) rotate(0deg) translate(-12.141791px,-3.457324px); } }\n@keyframes a0_t { 0% { transform: translate(20.626516px,21.982876px); } 25% { transform: translate(20.626516px,21.982876px); } 75% { transform: translate(35.584727px,20.530728px); } 100% { transform: translate(35.584727px,20.530728px); } }\n@keyframes a1_t { 0% { transform: translate(22.926552px,19.392687px); } 25% { transform: translate(22.926552px,19.392687px); } 75% { transform: translate(34.43591px,14.491686px); } 100% { transform: translate(34.43591px,14.491686px); } }\n@keyframes a2_t { 0% { transform: translate(21.196584px,19.892866px); } 25% { transform: translate(21.196584px,19.892866px); } 75% { transform: translate(29.438608px,18.07768px); } 100% { transform: translate(29.438608px,18.07768px); } }\n@keyframes a3_t { 0% { transform: translate(22.686523px,22.082769px); } 25% { transform: translate(22.686523px,22.082769px); } 75% { transform: translate(33.10677px,24.200485px); } 100% { transform: translate(33.10677px,24.200485px); } }\n@keyframes a4_t { 0% { transform: translate(18.176462px,22.632715px); } 25% { transform: translate(18.176462px,22.632715px); } 75% { transform: translate(25.631906px,22.632715px); } 100% { transform: translate(25.631906px,22.632715px); } }\n@keyframes a5_t { 0% { transform: translate(3.076569px,22.372923px); } 50% { transform: translate(-4.923431px,21.372923px); } 100% { transform: translate(-4.923431px,21.372923px); } }\n@keyframes a6_t { 0% { transform: translate(3.398365px,20.055261px); } 50% { transform: translate(-4.601635px,19.055262px); } 100% { transform: translate(-4.601635px,19.055262px); } }\n@keyframes a7_t { 0% { transform: translate(1.15634px,19.832859px); } 50% { transform: translate(-10.84366px,15.832858px); } 100% { transform: translate(-10.84366px,15.832858px); } }\n@keyframes a8_t { 0% { transform: translate(5.400621px,22.501322px); } 50% { transform: translate(-0.599379px,21.501322px); } 100% { transform: translate(-0.599379px,21.501322px); } }\n@keyframes a9_t { 0% { transform: translate(0.774039px,21.973635px); } 50% { transform: translate(-8.225961px,23.973635px); } 100% { transform: translate(-8.225961px,23.973635px); } }\n    ")), /*#__PURE__*/React.createElement("path", {
    id: "Brush",
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17,15.368L19,21.107C14.4093,22.2977,9.59071,22.2977,5,21.107L7,15.368M17,15.368L7,15.368M17,15.368L17,14.365C17,13.61,16.328,12.998,15.5,12.998C14.672,12.998,14,12.387,14,11.632L14,11.177L13.403,11.177M7,15.367L7,14.364C7,13.609,7.672,12.997,8.5,12.997C9.328,12.997,10,12.386,10,11.631L10,11.176L10.762,11.176M8.5,18.83L7.99,21.71M12,17.894L12,22M15.5,18.83L16.061,21.704M13.403,11.178L13.461,3.303C13.461,1.567,10.821,1.567,10.821,3.303L10.761,11.178M13.403,11.178L10.762,11.178",
    transform: "translate(12.1418,3.45732) translate(-12.1418,-3.45732)",
    style: {
      animation: "0.8s linear infinite both Brush_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(20.6265,21.9829)",
    style: {
      animation: "0.8s linear infinite both a0_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(22.9266,19.3927)",
    style: {
      animation: "0.8s linear infinite both a1_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(21.1966,19.8929)",
    style: {
      animation: "0.8s linear infinite both a2_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(22.6865,22.0828)",
    style: {
      animation: "0.8s linear infinite both a3_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(18.1765,22.6327)",
    style: {
      animation: "0.8s linear infinite both a4_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(3.07657,22.3729)",
    style: {
      animation: "0.8s linear infinite both a5_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(3.39837,20.0553)",
    style: {
      animation: "0.8s linear infinite both a6_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1.15634,19.8329)",
    style: {
      animation: "0.8s linear infinite both a7_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(5.40062,22.5013)",
    style: {
      animation: "0.8s linear infinite both a8_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L0.0384807,-0.00272613",
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(0.774039,21.9736)",
    style: {
      animation: "0.8s linear infinite both a9_t"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAni);
export default __webpack_public_path__ + "static/media/clear_ani.f50754882a09011f48f77cc9bce54a2e.svg";
export { ForwardRef as ReactComponent };